<div *ngIf="clearances !== undefined" style="display: block;padding-top:10px!important;">
  <app-data-table [columns]="clearanceTableColumns" [value]="clearances" [sortField]="sortField" [rows]="3"
                  [disableSearch]="true" [rightCaptionTemplate]="clearanceCaption">
    <ng-template #clearanceCaption>
      <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Add Clearance" pTooltip="Make New Clearance"
              tooltipPosition="top" (click)="onClickAddClearance()">
      </button>
    </ng-template>
    <ng-template #clearanceAction let-row="row">
      <button pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Update" tooltipPosition="top"
              (click)="onClickEditClearance(row)">
      </button>
      <button pButton type="button" class="icon-negative" icon="fa fa-trash" pTooltip="Delete" tooltipPosition="top"
              (click)="onClickDeleteClearance(row)">
      </button>
    </ng-template>
  </app-data-table>
  <p-confirmDialog></p-confirmDialog>

  <p-dialog *ngIf="clearanceToEdit&&clrDisplayDialog" [(visible)]="clrDisplayDialog"
            header="Clearance" [dismissableMask]="true" [responsive]="true" [modal]="true"
            [style]="PrimeNgConfig.DialogStyle40" (onHide)="onCancelEditClearance()">
    <form #clrDialogForm="ngForm">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Clearance Type*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="ClearanceType"
                      [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                      [options]="remainingClearanceTypeDropDown" [(ngModel)]="clearanceToEdit.type"
                      required></p-dropdown>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Status Type</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown name="clrStatusType"
                      [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}"
                      [options]="clrStatusTypeDropDown" [(ngModel)]="clearanceToEdit.statusType"
                      required>
          </p-dropdown>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Granting Institution*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <input pInputText id="grantingInstitution"
                 name="grantingInstitution" type="text" [(ngModel)]="clearanceToEdit.grantingInstitution"
                 required
                 [maxLength]="Validation.GrantingInstitutionMaxLength"/>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Clearance Granted On*</label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-calendar id="clrGrantedOn" name="clrGrantedOn" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxDobEndOn"
                      icon="fa fa-calendar" showIcon="true"
                      [(ngModel)]="clearanceToEdit.clearanceGrantedOn" required [monthNavigator]="true" readonlyInput="true"></p-calendar>
        </div>
      </div>
    </form>

    <p-footer>
      <div style="text-align:right;margin-top:10px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="onCancelEditClearance()"></button>
        <button pButton type="button" class="button-action" icon="fa fa-check" label="Add" (click)="onClickSaveClearance(clearanceToEdit)"
                [disabled]="!clrDialogForm.form.valid"></button>
      </div>
    </p-footer>
  </p-dialog>
</div>
